




























































































































































































import {Component, Vue} from 'vue-property-decorator';
import DietService from '../services/DietService';
import {Diet, Target} from '../types';

@Component
export default class Targets extends Vue {
  private targetItems: Target[] = [];
  private diet: number = 0;
  private snackbarText: string = '';
  private snackbarColor: string = 'blue-grey';
  private snackbar: boolean = false;
  private loading: boolean = false;
  private btnLoading: boolean = false;
  private dietName: string | undefined = '';
  private dietStream: string = '';
  private valid: boolean = false;
  private createDialog: boolean = false;
  private renameDialog: boolean = false;
  private headers: object[] = [
    {text: 'Nutrient id', value: 'nutrient_id', sortable: true},
    {text: 'Symbol', value: 'nutrientsymbol', sortable: false},
    {text: 'Target Value', value: 'target_value'},
    {text: 'Upper Limit', value: 'upper_limit'},
    {text: 'Lower Limit', value: 'lower_limit'},
    {text: 'Unit', value: 'unit', sortable: false}
  ];

  private async mounted() {
    try {
      this.loading = true;
      await this.$store.dispatch('getDiets');
    } catch (e) {
      this.displaySnackbar('Something went wrong while fetching the diets', 'error');
    } finally {
      this.loading = false;
    }
  }

  private async getTargets(id: string) {
    return this.$store.getters.getMealFood;
  }

  private async createDiet() {
    try {
      this.loading = true;
      if (this.dietName) {
        const {data} = await DietService.createDiet({name: this.dietName, stream: this.dietStream});
        this.$store.dispatch('addDiet', data);
        this.diet = data.id;
        this.loadTargets();
        this.displaySnackbar('Diet created!', 'blue-grey');
      }
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.loading = false;
      this.createDialog = false;
    }
  }

  private async loadTargets() {
    if (this.targets[this.diet]) {
      this.targetItems = Object.assign([], this.targets[this.diet]);
    } else {
      await this.$store.dispatch('getNutrientTargets', this.diet);
      this.targetItems = Object.assign([], this.targets[this.diet]);
    }
    this.populateTargets();
  }

  private populateTargets() {
    for (const target of this.targets['1']) {
      const index = this.targetItems.findIndex((item: Target) => item.nutrient_id === target.nutrient_id);
      if (index === -1) {
        this.targetItems.push({nutrient_id: target.nutrient_id, diet: this.diet});
      }
    }
  }

  private displaySnackbar(msg: string, color: string) {
    this.snackbarText = msg;
    this.snackbarColor = color;
    this.snackbar = true;
  }

  private async saveTargets() {
    try {
      this.loading = true;
      await DietService.saveTargets(this.targetItems);
      this.displaySnackbar('Targets saved!', 'blue-grey');
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.loading = false;
    }
  }

  private async deleteTarget(item: any) {
    if (!confirm(`are you sure you want to delete the target for ${this.nutrients[item.nutrient_id].nutrientname}?`)) {
      return;
    }
    this.loading = true;
    await DietService.deleteTarget(item.diet, item.nutrient_id);
    this.targets[this.diet] = undefined;
    await this.loadTargets();
    this.loading = false;
    this.displaySnackbar('Targets deleted', 'blue-grey');
  }

  private async renameDiet() {
    try {
      this.btnLoading = true;
      if (this.diet && this.dietName) {
        await DietService.updateDiet(this.diet, {name: this.dietName, stream: this.dietStream});
        this.$store.dispatch('updateDiet', {id: this.diet, name: this.dietName});
        this.displaySnackbar('Diet updated!', 'blue-grey');
      }
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.btnLoading = false;
      this.renameDialog = false;
    }
  }

  private async openUpdateDialog() {
    this.renameDialog = true;
    const currentDiet: { id: number, name: string, stream: string } | undefined =
        this.diets.find((item: { id: number, name: string }) => item.id === this.diet);
    if (currentDiet) {
      this.dietName = currentDiet.name || '';
      this.dietStream = currentDiet.stream || '';
    }
  }

  private async deleteDiet() {
    try {
      this.loading = true;
      if (confirm('Are you sure you want to delete this diet?') && await DietService.deleteDiet(this.diet)) {
        this.$store.dispatch('removeDiet', this.diet);
        this.diet = 1;
        await this.loadTargets();
        this.displaySnackbar('Diet deleted!', 'blue-grey');
      }
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.loading = false;
    }
  }

  private async selectDiet(id: number) {
    this.diet = id;
    await this.loadTargets();
  }

  private addNutrient(nutrient: { nutrientnameid: number }) {
    this.targetItems.unshift({nutrient_id: nutrient.nutrientnameid, diet: this.diet});
  }

  get targets() {
    return this.$store.getters.getTargets;
  }

  get nutrients() {
    return this.$store.getters.getNutrients;
  }

  get diets() {
    return this.$store.getters.getDiets;
  }

  get streams() {
    return this.$store.getters.getStreams;
  }

  get selectedDiet() {
    return this.diets.find((item: Diet) => item.id === this.diet);
  }

  get nutrientsToAdd() {
    const nutrients = [];
    for (const key in this.nutrients) {
      if (this.nutrients.hasOwnProperty(key)) {
        const id = this.nutrients[key].nutrientnameid;
        const index = this.targetItems.findIndex(
            (targetItem: Target) => targetItem.nutrient_id === id);
        if (index === -1) {
          nutrients.push(this.nutrients[id]);
        }
      }
    }
    return nutrients;
  }
}
